import { nanoid } from 'nanoid';

class SearchContextIdManager {
  constructor() {
    this.contextId = nanoid();
    this.lastState = { searchTerm: '', filters: '', searchType: null };
    this.isActiveSearchSession = false; // Track if we're in an active search session
  }
  serializeFilters(filters) {
    const serialized = {};
    for (const [key, value] of Object.entries(filters)) {
      if (value instanceof Set) {
        // Convert Set to sorted array for consistent comparison
        serialized[key] = Array.from(value).sort();
      } else {
        serialized[key] = value;
      }
    }
    return JSON.stringify(serialized);
  }

  updateContext(searchTerm, filters, searchType = null) {
    const currentState = {
      searchTerm,
      filters: this.serializeFilters(filters),
      searchType,
    };
    if (searchTerm !== '') {
      if (
        currentState.searchTerm !== this.lastState.searchTerm ||
        currentState.filters !== this.lastState.filters ||
        currentState.searchType !== this.lastState.searchType
      ) {
        this.contextId = nanoid();
        this.lastState = currentState;
      }
      this.isActiveSearchSession = true;
    }

    return this.contextId;
  }

  // Call this when user is actively viewing search results
  markSearchActive() {
    this.isActiveSearchSession = true;
  }

  // Call this when user leaves search page (navigates away)
  markSearchInactive() {
    this.isActiveSearchSession = false;
  }

  getContextId() {
    // Only return contextId if we're in an active search session
    return this.isActiveSearchSession ? this.contextId : undefined;
  }

  resetContext() {
    this.contextId = undefined;
    this.lastState = { searchTerm: '', filters: '', searchType: null };
    this.markSearchInactive();
  }
}

export default new SearchContextIdManager();
